<template>
  <div
    v-if="fetched"
    :class="{
      'ss-date': true,
      'has-tigger-button': triggerWithButton
    }">
    <date-picker
      trg="date"
      :id="id"
      :title="title"
      :limit="limit"
      :date="startTime"
      :option="option"
      v-model="date_picker"
      @change="$emit('picked')"
      class="form-control"
      :trigger-button-label="triggerButtonLabel"
      :trigger-with-button="triggerWithButton">
    </date-picker>
  </div>
</template>

<script>
import lar_errors from '../../helpers/Errors'
import myDatepicker from './DatePicker'

export default {
  name: 'ssDate',
  props: {
    id: '',
    limitfrom: '',
    limitto: '',
    name: '',
    placeholder: '',
    triggerButtonLabel: '',
    triggerWithButton: false,
    value: '',
    title: {
      type: String,
      default: 'input date'
    },
    dateType: {
      type: String,
      default: 'day'
    },
    dateFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    }
  },
  components: {
    'date-picker': myDatepicker,
    lar_errors
  },
  data () {
    return {
      startTime:  {
        time: ''
      },
      lar_errors: lar_errors,
      fetched: true,
      date_picker: this.value,
      limit: [],
      option: {
        type: this.dateType,
        week: ['Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'So', 'Ndz'],
        month: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
        format: this.dateFormat,
        placeholder: '',
        inputStyle: {
          'display': 'block',
          'line-height': 'inherit',
          'font-size': 'inherit',
          'border': '0',
          'box-shadow': '0',
          'border-radius': '0',
          'color': 'inherit',
          'width': '100%'
        },
        color: {
          header: '#232756',
          headerText: '#fff',
          checked: '#da1950'
        },
        buttons: {
          ok: 'Ok',
          cancel: 'Anuluj'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true, // as true as default
      }
    }
  },
  mounted () {
    // let _date_picker_date = document.querySelector("input.cov-datepicker");
    // _date_picker_date.onfocus = function(){
    //     _date_picker_date.blur();
    // };
    if (this.limitfrom || this.limitto) {
      this.fetched = false;
      this.limit = [{
        type: 'fromto',
        from: this.limitfrom ? this.limitfrom : '',
        to: this.limitto ? this.limitto : ''
      }];
      this.fetched = true
    }
    if (this.placeholder){
      this.option.placeholder = this.placeholder;
    }
    // if(this.startTime.time.toString() === ''){
    //     this.startTime.time = Vue.getCurrentDate();
    // }
  },
  methods: {
    opened () {
      this.$refs.blur.focus();
    }
  },
  watch: {
    'startTime.time': function (to, from) {
      this.$nextTick(function () {
        this.$emit('input', to);
      })
    },
    date_picker (to, from) {
      if(to !== from){
        this.$nextTick(function () {
          if(lar_errors.has(this.name)) {
            lar_errors.clear(this.name);
          }
          this.$emit('input', to);
        })
      }
    },
    value: function (to, from) {
      this.date_picker = to;
    },
    limitfrom (to) {
      if (this.limitfrom || this.limitto) {
        this.fetched = false;
        this.limit = [{
          type: 'fromto',
          from: this.limitfrom ? this.limitfrom : '',
          to: this.limitto ? this.limitto : ''
        }];
        this.fetched = true
      }
    },
    limitto (to) {
      if (this.limitfrom || this.limitto) {
        this.fetched = false;
        this.limit = [{
          type: 'fromto',
          from: this.limitfrom ? this.limitfrom : '',
          to: this.limitto ? this.limitto : ''
        }];
        this.fetched = true
      }
    }
  }
}
</script>

<style lang="scss">
table.table input.cov-datepicker{
  text-align: center;
}
table.table .text-left input.cov-datepicker{
  text-align: left;
}
.ss-date.is-disabled .form-control{
  background-color: #f5f6f7;
  input{
    background-color: #f5f6f7;
  }
}
.is-invalid.ss-date .form-control{
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.is-invalid.ss-date + .invalid-feedback{
  display: block;
}
</style>
